import { createPlacementFrontend } from '@post-office/message-maker-browser/create-placement-frontend';

import {
	type CustomRenderer,
	type PlacementBrowserConfig,
	type PlacementMessageFrontendFactory,
	type PlacementRenderer,
} from '@post-office/message-maker-browser/types';

import {
	type AppProps,
	JiraIssueViewCommentTopBanner,
	type PlacementMessages,
	type PlacementRenderProps,
} from './placement';

export { type AppProps, type PlacementRenderProps } from './placement';

const placementConfig: PlacementBrowserConfig = {
	placementId: 'jira-issue-view-comment-top-banner',
};

const placement = {
	createFrontend:
		createPlacementFrontend<CustomRenderer<PlacementRenderProps>['frontend']>(placementConfig),
};

export const createFrontend: <U extends AppProps>(
	placementRenderer: PlacementRenderer<PlacementMessages, U>,
) => PlacementMessageFrontendFactory<PlacementMessages, U> = placement.createFrontend;

export const PlacementFrontend: PlacementMessageFrontendFactory<PlacementMessages, AppProps> =
	createFrontend<AppProps>((Messages) => (appProps) => (
		<JiraIssueViewCommentTopBanner Messages={Messages} {...appProps} />
	));
